import { email } from 'settings';

export const SignupVerifying = {
  transclude: true,
  bindings: {
    isLoading: '<',
    message: '<',
  },

  template: `
    <div class="signup-verifying">
      <h1 class="h2 text-center text-white mb-4">
        <spinner is-loading="$ctrl.isLoading">
          <ng-transclude></ng-transclude>
        </spinner>
      </h1>
      <div class="col-md-8 mx-auto">
        <alert class="bg-cz-theme" ng-hide="$ctrl.message">
          <span class="text-white bg-cz-theme">
            We're creating your account, please do not refresh the
            page.
          </span>
        </alert>
        <alert type="danger" ng-show="$ctrl.message">
          <div ng-bind-html="$ctrl.message"></div>
        </alert>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupVerifying.js